import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

/**
 * BrowseCategoriesSection
 * "Thousands of services across every skill"
 * Placed after <HowItWorksSection /> in Home.js.
 * All categories are hardcoded — no DB calls.
 */

const CATEGORIES = [
  {
    title: "Digital Marketing",
    tags: "SEO · Social Ads · Email",
    slug: "digital-marketing",
  },
  {
    title: "Home Maintenance",
    tags: "Plumbing · HVAC · Remodeling",
    slug: "home-services",
  },
  {
    title: "Programming & Tech",
    tags: "Web · Mobile Apps · AI",
    slug: "programming-tech",
  },
  {
    title: "Graphic Designing",
    tags: "Logos · Brand · Illustration",
    slug: "design-creative",
  },
  {
    title: "Video & Animation",
    tags: "Editing · Explainers · Ads",
    slug: "video-animation",
  },
  {
    title: "Writing & Translation",
    tags: "Articles · Resumes · Editing",
    slug: "writing-translation",
  },
  {
    title: "E-Commerce",
    tags: "Amazon · Shopify · Etsy",
    slug: "digital-marketing",
  },
  {
    title: "Business and many more...",
    tags: "Sales · Finance · Legal · HR",
    slug: "digital-marketing",
  },
];

const BrowseCategoriesSection = () => {
  const navigate = useNavigate();

  return (
    <SectionStyled>
      <div className="container py-5">
        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="section-title">
            Thousands of services
            <br />
            across every skill
          </h2>
          <p className="section-subtitle mx-auto">
            From home repairs around the corner to specialists across the globe
            — explore the categories people hire for most.
          </p>
        </div>

        {/* Grid */}
        <div className="row g-0">
          {CATEGORIES.map((cat) => (
            <div
              key={cat.title}
              className="col-6 col-md-3"
            >
              <div className="cat-card">
                <h5 className="cat-title">{cat.title}</h5>
                <p className="cat-tags">{cat.tags}</p>
                <div className="cat-underline" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionStyled>
  );
};

export default BrowseCategoriesSection;

/* ── Styles ──────────────────────────────────────────────────────────────── */
const DARK = "#1c1c2e";
const GREY = "#888888";
const BORDER = "#ececec";

const SectionStyled = styled.section`
  background: #ffffff;
  border-top: 1px solid ${BORDER};

  .section-title {
    font-size: clamp(1.7rem, 3.5vw, 2.5rem);
    font-weight: 800;
    color: ${DARK};
    font-family: "MS_Bold", "Arial Black", sans-serif;
    line-height: 1.2;
    margin-bottom: 12px;
  }

  .section-subtitle {
    font-size: 1rem;
    color: black;
    max-width: 540px;
    line-height: 1.6;
  }

  /* ── Category card ── */
  .cat-card {
    padding: 28px 20px 20px;
    cursor: pointer;
    border-right: 1px solid ${BORDER};
    border-bottom: 1px solid ${BORDER};
    height: 100%;
    transition: background 0.18s ease;

    &:hover {
      background: #f8fffe;

      .cat-title {
        color: #0fd3bb;
      }

      .cat-underline {
        background: #0fd3bb;
      }
    }
  }

  /* Remove right border on last column of each row */
  .col-6:nth-child(2n) .cat-card,
  .col-md-3:nth-child(4n) .cat-card {
    border-right: none;
  }

  .cat-title {
    font-size: 15px;
    font-weight: 800;
    color: ${DARK};
    font-family: "MS_Bold", "Arial Black", sans-serif;
    margin-bottom: 6px;
    transition: color 0.18s ease;
  }

  .cat-tags {
    font-size: 13px;
    color: ${GREY};
    margin-bottom: 16px;
    line-height: 1.4;
  }

  .cat-underline {
    height: 2px;
    width: 36px;
    background: ${BORDER};
    border-radius: 2px;
    transition: background 0.18s ease;
  }

  /* On mobile (col-6) remove right border only on even columns */
  @media (max-width: 767px) {
    .col-md-3:nth-child(4n) .cat-card {
      border-right: 1px solid ${BORDER};
    }
    .col-6:nth-child(2n) .cat-card {
      border-right: none;
    }
    /* bottom row — remove bottom border */
    .col-6:nth-last-child(-n + 2) .cat-card {
      border-bottom: none;
    }
  }

  @media (min-width: 768px) {
    .col-6:nth-child(2n) .cat-card {
      border-right: 1px solid ${BORDER};
    }
    /* bottom row (last 4) — remove bottom border */
    .col-md-3:nth-last-child(-n + 4) .cat-card {
      border-bottom: none;
    }
  }
`;
